// extracted by mini-css-extract-plugin
export default {"center":"NotFound_center__kzLds"};